import { Phone, MessageCircle } from "lucide-react";
import { BUSINESS, IMAGES, waLink } from "../data/site";
import { Reveal } from "./Reveal";
import { useQuote } from "./QuoteModal";

export default function FinalCta() {
  const { openQuote } = useQuote();
  return (
    <section className="relative py-28 sm:py-36 bg-[#0D0D0D] overflow-hidden grain" data-testid="final-cta">
      <div className="absolute inset-0">
        <img src={IMAGES.rooftops} alt="Rooftops across a Greater Manchester suburb at dusk" loading="lazy" decoding="async" className="w-full h-full object-cover opacity-35" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D0D0D] via-[#0D0D0D]/60 to-[#0D0D0D]" />
      </div>
      <div className="absolute inset-0 opacity-15 bg-[radial-gradient(circle_at_50%_50%,#D4AF37,transparent_60%)]" />
      <div className="container-lux relative text-center">
        <Reveal>
          <p className="overline mb-4 !mx-auto">Ready When You Are</p>
          <h2 className="font-head text-4xl sm:text-6xl lg:text-7xl uppercase tracking-tighter font-bold leading-[0.95]">
            Ready To <span className="text-gold-metallic">Protect</span><br />Your Home?
          </h2>
          <p className="mt-6 text-[#C8C8C8] max-w-xl mx-auto">Request your free, no-obligation quotation today and join hundreds of happy homeowners.</p>
          <div className="mt-10 flex flex-wrap gap-4 justify-center">
            <a href={BUSINESS.phoneHref} data-testid="cta-call" className="btn-ghost rounded-sm px-7 py-4 text-sm inline-flex items-center gap-2">
              <Phone size={16} strokeWidth={1.5} /> Call Now
            </a>
            <button onClick={openQuote} data-testid="cta-quote" className="btn-gold rounded-sm px-7 py-4 text-sm">Get Free Quote</button>
            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="cta-whatsapp"
              className="btn-ghost rounded-sm px-7 py-4 text-sm inline-flex items-center gap-2">
              <MessageCircle size={16} strokeWidth={1.5} /> WhatsApp Us
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
